<template>
  <div @click="popuphide">
    <div class="pop_replace" @click="popuphide"></div> 
    <div  class="pop_up">
        <img src="@/assets/director/recruit/images/rightpop-bg.png" class="pop_back">
        <div class="pop_news">
          <!--<p class="pop_time">{{date}}</p>-->
          <ul>
            <li  v-for="(item, index) in logs" :key="index"  :class="item.type==1 ? 'pop_news_item_right' : 'pop_news_item_left'">
              <div v-if="item.type==1">
                <span> {{item.content}} </span>
                <img :src="item.avatar">
              </div>

              <div v-else>
                <img :src="item.avatar">
                <span> {{item.content}} </span>
              </div>
              
            </li>
          </ul>
        </div>
    </div>

  </div>

</template>

<script>
export default {
    data(){
        return{
          
        }
    },
    props: {
        logs: {
          type: Array,
          default: () => {},
        },
    },
    methods:{
      popuphide(){
        this.$emit('dismissLog')
      },
    
      timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
        let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
        let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
        let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
        // let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
        // return year + "年" + month + "月" + date +"日"+" "+hh+":"+mm ;
        this.date = year + "-" + month + "-" + date +" "+hh+":"+mm ;
        console.log(this.date);
      },
        nowTimes() {
          this.timeFormate(new Date());
          this.timer = setTimeout(this.nowTimes, 30 * 1000);
        },
      },

    created() {
     this.nowTimes();
   },
    //销毁定时器
     beforeDestroy: function() {
    if (this.timer) {
      console.log("销毁定时器")
      clearTimeout(this.timer); //在Vue实例销毁前，清除我们的定时器
    }
  }

}
</script>

<style lang="scss" scoped>
.pop_replace{
    width: 30px;
    height: 30px;
    // background-color: #4C71DB; 
    position:absolute;
    right: 275px;
    top: 105px;
    z-index: 1;
  }
  .pop_up{
  height: 243px;
  position: absolute;
  right: 0;
  top: 0;
  // position: relative;
  }
  .pop_back{
    height: 240px;
  }
  .pop_news .pop_time{
  margin-top: 10px;
  font-size: 10px;
  color: #999999;
  text-align: center;
  }
  .pop_news{
    width: 250px;
    height: 220px;
    // background-color: #4c71db;
    position: absolute;
    right:0px;
    top: 10px;
    z-index: 2;
  }

.pop_news ul{
  height: 175px;
  margin-top: 15px;
  overflow-x: hidden;
  overflow-y: scroll;
  // background-color: #4c71db;
}
.pop_news ul::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px;
  /*高宽分别对应横竖滚动条的尺寸*/
  // height: 57px;
}

.pop_news ul li img{
  width: 26px;
  border-radius: 50%;
}
.pop_news .pop_time{
  margin-top: 10px;
  font-size: 10px;
  color: #999999;
  text-align: center;
  }

  .pop_news_item_left,.pop_news_item_right{
    // border: 1px solid red;
    margin-top: 5px;
    display: flex;
    align-items:center;
    margin-bottom: 20px;

    div{
      display: flex;
      align-items:center;
    }
  }
  .pop_news_item_left span{
    font-size: 8px;
    color: #333333;
  // border: 1px solid red;
    margin-left: 15px;
  }
  .pop_news_item_right {
    // border: 1px solid red;
    // margin-right: 15px;
    width: 100px;
    margin-left: 140px;
  }
  .pop_news_item_right span{
    font-size: 11px;
    color: #333333;
  // border: 1px solid red;
    margin-right: 15px;
  }

</style>